(function () {
    var bookPage = {
        $bookPage: $('.book-page'),
        $purchaseBtn: $('.book-page__content .purchase_for_us_ca'),
        $bookPageAside: $('.book-page__aside'),

        init: function () {
            if (this.$bookPage.length) {
                bookPage.addPurchaseBtn();
            }
        },

        addPurchaseBtn: function () {
            if (this.$purchaseBtn.length) {
                const href = this.$purchaseBtn?.children()[0]?.href;
                const purchaseCustomBtn = `<div class="add-journal-to-cart">
                    <div class="purchase-items">
                        <header>
                            <a class="purchase-item add-article-to-cart add-article-to-cart__white" href=${href}>
                                <span class="icon-shopping-cart"></span>
                                <span class="add-article-to-cart__title">Buy from US/Canada</span>
                            </a>
                        </header>
                    </div>
                </div>`;
                this.$bookPageAside.append(purchaseCustomBtn);
            }
        },
    };
    UX.bookPage = bookPage; // add to global namespace
})();
